import React, { useEffect, useState } from "react";
import {
  EyeIcon,
  EyeSlashIcon,
  CheckIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

const ConfirmPasswordInput = ({ label, setPassword = () => {}, setPasswordChecks = ()=>{} }) => {
  // const { label, placeholder, errorMessage, onChange, id, ...inputProps } =
  //   props;

  const [values, setValues] = useState({
    password: "",
    showPassword: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [focused, setFocused] = useState(false);

  const [showPassErr, setShowPassErr] = useState(false);
  const [checkPwdLength, setCheckPwdLength] = useState(false);
  const [checkCapital, setCheckCapital] = useState(false);
  const [checkDigit, setCheckDigit] = useState(false);
  const [checkNoSpace, setCheckNoSpace] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleFocus = (e) => {
    setFocused(true);
  };

  const onPassWordChange = () => {
    setShowPassErr(false);

    let isError = false;

    let passwordError = "";
    if (!values?.password) {
      setShowPassErr(true);
      if (!passwordError) {
        passwordError = "Password length should be atleast 6 character";
      }
      setCheckPwdLength(true);
      setCheckDigit(true);
      setCheckNoSpace(true);
      setCheckCapital(true);
      isError = true;
      setShowPassErr(true);
    }
    if (
      values?.password &&
      !(values?.password.length > 7 && values?.password.length < 21)
    ) {
      if (!passwordError) {
        passwordError = "Password length should be atleast 6 character";
      }
      setCheckPwdLength(true);
      isError = true;
      setShowPassErr(true);
    }
    const str = /(?=.*?[A-Z]).*/;
    if (values?.password && !str.test(values?.password)) {
      if (!passwordError) {
        passwordError = "Password length should be atleast 6 character";
      }
      setCheckCapital(true);
      isError = true;
      setShowPassErr(true);
    }
    const digitRegex = /^(?=.*\d).+$/;

    if (values?.password && !digitRegex.test(values?.password)) {
      if (!passwordError) {
        passwordError = "Password length should be atleast 6 character";
      }
      setCheckDigit(true);
      isError = true;
      setShowPassErr(true);
    }
    if (
      values?.password &&
      values?.password.length > 1 &&
      values?.password.split(" ").length > 1
    ) {
      setCheckNoSpace(true);
      isError = true;
      setShowPassErr(true);
    }

    (!isError) && setPasswordChecks(true); 
    return isError ? false : true;
  };

  const [changed, setChanged] = useState(0);
  useEffect(() => {
    if (changed > 0) onPassWordChange();
  }, [changed]);


  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
    setPassword(event.target.value);
    // setErrorValues({ ...errorValues, [prop]: "" });
    if (prop === "password") {
      setCheckPwdLength(false);
      setCheckDigit(false);
      setCheckNoSpace(false);
      setCheckCapital(false);
      setShowPassErr(false);
      setChanged((prev) => prev + 1);
    }
  };
  return (
    <>
      <div className="formInput relative ">
        <label>{label}</label>

        <input
          className="h-[45px]"
          // {...inputProps}
          type={showPassword ? "text" : "password"}
          // placeholder={placeholder}
          // onChange={onChange}
          onBlur={handleFocus}
          //onFocus={() => inputProps.name === "text" && setFocused(true)}
          focused={focused.toString()}
          value={values?.password || ""}
          autoComplete="new-password"
          onChange={handleChange("password")}
          onFocus={() => {
            onPassWordChange();
            setShowPassErr(true);
          }}
          // onFocus={() => inputProps.name === "text" && setFocused(true)}

          onPointerOut={() => {
            setCheckPwdLength(false);
            setCheckDigit(false);
            setCheckNoSpace(false);
            setCheckCapital(false);
            setShowPassErr(false);
          }}
        />
        {/* <span>{errorMessage}</span> */}

        <div className="text-2xl absolute top-[42px] right-5">
          <div
            onClick={handleClickShowPassword}
            onMouseDown={handleMouseDownPassword}
          >
            {showPassword ? (
              <div className="cursor-pointer bg-white z-10">
                <EyeSlashIcon className="text-[#B0B6BA] h-6" />
              </div>
            ) : (
              <div className="cursor-pointer  bg-white z-10">
                <EyeIcon className="text-[#B0B6BA] h-6" />
              </div>
            )}
          </div>
        </div>
      </div>
      {showPassErr && (
        <div className="passwordValidationInfo">
          <p style={{ marginLeft: "10px" }}>Password must include</p>
          <div
            style={{
              display: "flex",
              padding: "5px 15px",
              color: checkPwdLength ? "#FF0000" : "#34A853",
            }}
          >
            {checkPwdLength ? (
              <XMarkIcon className="h-6" />
            ) : (
              <CheckIcon className="h-6" />
            )}
            <p
              style={{
                marginLeft: "10px",
                color: checkPwdLength ? "#FF0000" : "#34A853",
              }}
            >
              {" "}
              8 - 20 Characters
            </p>
          </div>
          <div
            style={{
              display: "flex",
              padding: "5px 15px",
              color: checkCapital ? "#FF0000" : "#34A853",
            }}
          >
            {checkCapital ? (
              <XMarkIcon className="h-6" />
            ) : (
              <CheckIcon className="h-6" />
            )}
            <p
              style={{
                marginLeft: "10px",
                color: checkCapital ? "#FF0000" : "#34A853",
              }}
            >
              At least one capital letter
            </p>
          </div>
          <div
            style={{
              display: "flex",
              padding: "5px 15px",
              color: checkDigit ? "#FF0000" : "#34A853",
            }}
          >
            {checkDigit ? (
              <XMarkIcon className="h-6" />
            ) : (
              <CheckIcon className="h-6" />
            )}
            <p
              style={{
                marginLeft: "10px",
                color: checkDigit ? "#FF0000" : "#34A853",
              }}
            >
              At least one number
            </p>
          </div>
          <div
            style={{
              display: "flex",
              padding: "5px 15px",
              color: checkNoSpace ? "#FF0000" : "#34A853",
            }}
          >
            {checkNoSpace ? (
              <XMarkIcon className="h-6" />
            ) : (
              <CheckIcon className="h-6" />
            )}
            <p
              style={{
                marginLeft: "10px",
                color: checkNoSpace ? "#FF0000" : "#34A853",
              }}
            >
              No spaces
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfirmPasswordInput;
